<ng-container *transloco="let t; read: 'home'">
  <div class="p-grid p-nogutter p-jc-center forWho">
    <div class="p-col-12 forWho__header">
      <h2 class="home-heading p-text-bold">
        {{ t('for-who.header.1') }}
        <span>{{ t('for-who.header.2') }}</span>
      </h2>
      <h2 class="home-heading p-text-normal">{{ t('for-who.header.3') }}</h2>
      <a *ngIf="!onPath('/gap-dla-firm')" routerLink="/gap-dla-firm">{{
        t('tab.showMore')
      }}</a>
    </div>

    <div class="p-col-12 mb-12 p-text-center forWho__charts">
      <div class="p-grid">
        <div class="p-col-12 p-md-6">
          <h2 class="textBlue">
            {{ t('for-who.content.1') }}
          </h2>
          <img
            class="circle-image"
            src="assets/images/06_Biznesmen.jpg"
            alt="Leasing i Kredyt"
            loading="lazy"
            decoding="async" width="800" height="800">
          <p
            class="textBlue p-mt-3"
            [innerHTML]="t('for-who.content.3')"></p>
          <a *ngIf="!onPath('/gap-leasing')" routerLink="/gap-leasing">{{
            t('tab.showMore')
          }}</a>
        </div>
        <div class="p-col-12 p-md-6">
          <h2 class="textBlue">
            {{ t('for-who.content.2') }}
          </h2>
          <img
            class="circle-image"
            src="assets/images/07_audi_srodek.jpg"
            alt="Zakup za Gotówkę"
            loading="lazy"
            decoding="async" width="800" height="800">
          <p
            class="textBlue p-mt-3"
            [innerHTML]="t('for-who.content.4')"></p>
        </div>
      </div>
    </div>

    <div class="p-col-12 forWho__header">
      <h2 class="home-heading p-text-normal">{{ t('for-who.header.4') }}</h2>
    </div>

    <!-- Vehicle grid only in browser: avoids SSG emitting 9 eager background URLs -->
    <div
      *ngIf="showVehicles"
      class="p-col-12 forWho__vehicles">
      <ng-container *ngFor="let vehicle of vehicles">
        <div class="vehicleItem">
          <div class="vehicleWrapper circle-image">
            <img
              class="vehicleWrapper__img"
              [src]="'assets/images/' + vehicle.img"
              [alt]="vehicle.name"
              loading="lazy"
              decoding="async" />
          </div>
          <div class="vehicleType">
            <p [innerHTML]="vehicle.name"></p>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="p-col-12 forWho__texts p-pt-2">
      <p class="p-text-bold p-text-center">
        {{ t('for-who.content.5') }}
      </p>
      <p class="p-text-center p-mt-3">
        {{ t('for-who.content.6') }}
        <a
          routerLink="/"
          fragment="contact"
          class="textYellow p-text-bold textUnderlined"
          >{{ t('for-who.content.7') }} ></a
        >
      </p>
    </div>
  </div>
</ng-container>
